export default class Pagination {
    constructor(root, type, callback) {
        this.root = root;
        this.type = type;
        this.callback = callback;
        this.current_page = 1;
        this.num_pages = 1;

        if(type == 'paged') {
            this.previous_button = this.root.querySelector('.js-pagination-previous');
            this.next_button = this.root.querySelector('.js-pagination-next');
            this.button_container = this.root.querySelector('.js-pagination-button-container');

            this.previous_button.addEventListener('click', () => {
                if(this.current_page > 1) {
                    this.current_page -= 1;
                    this.callback();
                }
            });

            this.next_button.addEventListener('click', () => {
                if(this.current_page <= this.num_pages) {
                    this.current_page += 1;
                    this.callback();
                }
            });
        } else if(type == 'button') {
            this.root.addEventListener('click', (event) => {
                event.preventDefault();

                this.current_page += 1;
                this.callback();
            });
        }
    }

    setupPageOptions() {
        this.page_options = this.root.querySelectorAll('.js-pagination-button');

        this.page_options.forEach((page_option) => {
            page_option.addEventListener('click', (e) => {
                this.current_page = parseInt(e.target.dataset.value);

                this.callback();
            });
        });
    }

    update(num_pages) {
        this.num_pages = num_pages;

        this.button_container.innerHTML = '';

        this.getIndexes().forEach((index) => {
            if(index == "...") {
                this.button_container.innerHTML += '<p class="pagination__page-button --ellipses" data-value="...">...</p>';
            } else {
                this.button_container.innerHTML += '<p class="pagination__page-button js-pagination-button" data-value="' + index + '">' + index + '</p>';
            }
        });

        this.setupPageOptions();

        if(this.num_pages == this.current_page || this.num_pages == 0) {
            this.next_button.classList.add('--disabled');
        } else {
            this.next_button.classList.remove('--disabled');
        }

        if(this.current_page == 1) {
            this.previous_button.classList.add('--disabled');
        } else {
            this.previous_button.classList.remove('--disabled');
        }

        this.page_options.forEach((page_option) => {
            page_option.classList.remove('--active');

            if(this.current_page == parseInt(page_option.dataset.value)) {
                page_option.classList.add('--active');
            }
        });
    }

    getIndexes() {
        var pagination_values = [];

        if(this.num_pages <= 6) {
            for(var i = 1; i <= this.num_pages; i++) {
                pagination_values.push(i);
            }
        } else if(this.current_page + 5 < this.num_pages) {
            pagination_values.push(this.current_page);
            pagination_values.push(this.current_page + 1);
            pagination_values.push(this.current_page + 2);
            pagination_values.push("...");
            pagination_values.push(this.num_pages - 2);
            pagination_values.push(this.num_pages - 1);
            pagination_values.push(this.num_pages);
        } else {
            for(var i = this.num_pages; i >= this.num_pages - 5; i--) {
                pagination_values.unshift(i);
            }

            pagination_values.unshift("...");
        }

        return pagination_values;
    }
}
